import request from '../request'
export function getnewMarkerBuy(data) {
  return request.get('/databoard/newMarkerBuy', {
    params: data
  })
}
export function getepScale(data) {
  return request.get('/databoard/epScale', {
    params: data
  })
}
export function getnewRegister(data) {
  return request.get('/databoard/newRegister', {
    params: data
  })
}
export function getindustryData(data) {
  return request.get('/databoard/industryData', {
    params: data
  })
}
export function getareaDatas(data) {
  return request.get('/databoard/areaDatas', {
    params: data
  })
}
export function getdayTakerOrderData(data) {
  return request.get('/databoard/dayTakerOrderData', {
    params: data
  })
}
export function getmonthTakerOrderData(data) {
  return request.get('/databoard/monthTakerOrderData', {
    params: data
  })
}
export function getyearTakerOrderData(data) {
  return request.get('/databoard/yearTakerOrderData', {
    params: data
  })
}
export function gethistoryTakerOrderData(data) {
  return request.get('/databoard/historyTakerOrderData', {
    params: data
  })
}
export function getbaseinfo(data) {
  return request.get('/databoard/baseinfo', {
    params: data
  })
}
export function getEnterpriseMgrList(data) {
  return request.get('/enterprise/mgr/list', {
    params: data
  })
}
export function getEnterpriseMgrCount(data) {
  return request.get('/enterprise/mgr/count', {
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/model/index.js